import { render, staticRenderFns } from "./FullScreenOverlay.vue?vue&type=template&id=5e2a3ae0&scoped=true"
import script from "./FullScreenOverlay.vue?vue&type=script&lang=js"
export * from "./FullScreenOverlay.vue?vue&type=script&lang=js"
import style0 from "./FullScreenOverlay.vue?vue&type=style&index=0&id=5e2a3ae0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2a3ae0",
  null
  
)

export default component.exports